:host {
  display: block;
}
.qumra-input{
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.qumra-input-container{
     border: 1px solid #E5E5E5;
     border-radius: 4px;
     display: flex;
     background-color: white;
     align-items: center;
     gap: 8px;
     padding: 0px 8px;
     width: 100%;
     height: 40px;
}
.icon-container{
  width: max-content;
}
.qumra-input-label{
  font: bold;
}
.qumra-input-text{
  flex: 1 1 0%;
   outline: none;
   height: 100%;
   padding: 0px;
   border: none;
  background-color: transparent;
   
}
.qumra-input-icon{
   width: 18px;
   height: 18px;
   
}